module.exports = __webpack_public_path__ + "media/pdf/321sprzedane_banner-42524ebc.png";